import type { TransferRepository } from '@/core/transfer'
import type { UseCase } from '@/core/shared'

export const acceptTransfer: UseCase<TransferRepository, 'acceptTransfer'> = repository => {
  return async (token) => {
    return await repository.acceptTransfer(token)
  }
}
